var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.title))]),_c('td',[_c('AppSwitch',{on:{"toggleCheck":_vm.toggleActive}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }